import React from "react";
//import Link from "next/link";
import styles from "./button.module.css";
import { withDecorators } from "@/utils/StylesUtils";

export enum ButtonType {
  DEFAULT = "default",
  SECONDARY = "secondary",
  ERROR = "error",
}

export enum ButtonSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export interface ButtonProps {
  label: string;
  onClick?: () => void;
  icon?: any;
  type?: ButtonType;
  className?: string;
  /**
   * Route to redirect the user on button click
   */
  href?: string;
  /**
   * How large should the button be?
   */
  size?: ButtonSize;

  fullWidth?: boolean;

  target?: string;

  disabled?:boolean;
}

/**
 * Primary UI component for user interaction
 */
export const Button = (props: ButtonProps) => {
  const {
    label,
    onClick,
    icon,
    type = ButtonType.DEFAULT,
    className,
    href,
    size = ButtonSize.MEDIUM,
    fullWidth,
    target,
    disabled = false
  } = props;

  let buttonStyles : string[] = [type, size];

  if(fullWidth){
    buttonStyles = buttonStyles.concat('full_width');
  }

  if(disabled){
    buttonStyles = buttonStyles.concat('disabled');
  }

  if (href) {
    return (
      <a
        className={withDecorators(styles, "button", buttonStyles, className)}
        href={href}
        title={label}
        target={target}
      >
        {icon && <div className={styles.button_icon}>{icon}</div>}
        {label}
      </a>
    );
  }

  return (
    <button
      className={withDecorators(styles, "button", buttonStyles, className)}
      onClick={onClick}
    >
      {icon && <div className={styles.button_icon}>{icon}</div>}
      {label}
    </button>
  );
};
